/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldCheckboxV1Dto } from './FieldCheckboxV1Dto';
import type { FieldMentionV1Dto } from './FieldMentionV1Dto';
import type { FieldRadioGroupV1Dto } from './FieldRadioGroupV1Dto';
import type { FieldSignatureV1Dto } from './FieldSignatureV1Dto';
import type { FieldTextV1Dto } from './FieldTextV1Dto';
import type { SmsNotificationV1Dto } from './SmsNotificationV1Dto';
export type CreateSignerResponseV1Dto = {
  /**
   * UUID of the signer
   */
  id: string;
  /**
   * Information about the signer
   */
  info: Record<string, any>;
  /**
   * Status of the signature
   */
  status: CreateSignerResponseV1Dto.status;
  /**
   * Fields assigned to the signer
   */
  fields?: Array<
    | FieldSignatureV1Dto
    | FieldTextV1Dto
    | FieldMentionV1Dto
    | FieldCheckboxV1Dto
    | FieldRadioGroupV1Dto
  > | null;
  /**
   * Level of the signature
   */
  signature_level: CreateSignerResponseV1Dto.signature_level;
  /**
   * The signature authentication mode
   */
  signature_authentication_mode?: CreateSignerResponseV1Dto.signature_authentication_mode | null;
  /**
   * The link to the signature page
   */
  signature_link?: string | null;
  /**
   * The expiration date of the signature link
   */
  signature_link_expiration_date?: string | null;
  /**
   * A preview image of the signature
   */
  signature_image_preview?: string | null;
  /**
   * The redirect URLs after signing
   */
  redirect_urls: Record<string, any>;
  /**
   * Custom text for the signer
   */
  custom_text: Record<string, any>;
  /**
   * The delivery mode for the signer
   */
  delivery_mode: CreateSignerResponseV1Dto.delivery_mode;
  /**
   * The ID of the identification attestation
   */
  identification_attestation_id?: string | null;
  /**
   * SMS notification settings
   */
  sms_notification: SmsNotificationV1Dto;
  /**
   * Email notification settings
   */
  email_notification: Record<string, any>;
  /**
   * Whether pre-identity verification is required
   */
  pre_identity_verification: boolean;
  /**
   * Whether pre-identity verification is required
   */
  pre_identity_verification_required: boolean;
};
export namespace CreateSignerResponseV1Dto {
  /**
   * Status of the signature
   */
  export enum status {
    APPROVAL = 'approval',
    CANCELED = 'canceled',
    DECLINED = 'declined',
    DELETED = 'deleted',
    DONE = 'done',
    DRAFT = 'draft',
    EXPIRED = 'expired',
    INITIATED = 'initiated',
    ONGOING = 'ongoing',
    REJECTED = 'rejected',
  }
  /**
   * Level of the signature
   */
  export enum signature_level {
    ELECTRONIC_SIGNATURE = 'electronic_signature',
    ADVANCED_ELECTRONIC_SIGNATURE = 'advanced_electronic_signature',
    QUALIFIED_ELECTRONIC_SIGNATURE = 'qualified_electronic_signature',
  }
  /**
   * The signature authentication mode
   */
  export enum signature_authentication_mode {
    OTP_EMAIL = 'otp_email',
    OTP_SMS = 'otp_sms',
    NO_OTP = 'no_otp',
  }
  /**
   * The delivery mode for the signer
   */
  export enum delivery_mode {
    EMAIL = 'email',
    NONE = 'none',
  }
}
